import { createContext } from 'react';

export const CustomerContactCreditContext = createContext({
  loading: false,
  error: false,
  data: {},
  refresh: () => {},
  update: (data: any) => {},
});
